import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Calendar } from "../../../Schedule/Schedule/Calendar";
import { Box, Grid } from "@mui/material";
import NoData from "../../../../components/UI/NoData";
import { GridColDef } from "@mui/x-data-grid";
import Table from "../../../../components/UI/Table/Table";
import {
  ITriageCheckInRule,
  ITriageEmergencyDepartments,
} from "../../../../models/triage";
import { CheckInButtonTriage } from "../CheckInButtonTriage";

interface IMySchedulesTableProps {
  data: ITriageEmergencyDepartments[];
  checkInRule: ITriageCheckInRule;
}

const TRASNLATION_PATH = "page.triageEmergencyDepartment.";

const MyTriagesTable: React.FC<IMySchedulesTableProps> = ({
  data,
  checkInRule,
}) => {
  const { t } = useTranslation();

  const columns: GridColDef<ITriageEmergencyDepartments>[] = [
    {
      field: "created",
      headerName: t(TRASNLATION_PATH + "date")!,
      flex: 1,
      minWidth: 200,
      renderCell: ({ row: { created } }) => <Calendar date={created} />,
    },

    {
      field: "pacientName",
      headerName: t(TRASNLATION_PATH + "pacientName")!,
      minWidth: 200,
      flex: 1,
      renderCell: ({ row: { individual } }) => individual.name,
    },
    {
      field: "anamnesis",
      headerName: t(TRASNLATION_PATH + "anamnesi")!,
      minWidth: 200,
      flex: 1,
    },
  ];

  if (checkInRule) {
    columns.push({
      field: "checkIn",
      headerName: t(TRASNLATION_PATH + "checkin")!,
      flex: 1,
      renderCell: ({
        row: {
          created,
          id,
          patientEncounterId,
          individualTasyInsuranceFavorite,
        },
      }) => (
        <CheckInButtonTriage
          patientEncounterId={patientEncounterId}
          checkInRule={checkInRule}
          individualTasyInsuranceFavorite={individualTasyInsuranceFavorite}
          created={created}
          id={id}
        />
      ),
    });
  }

  return (
    <Box pb={2} height={"100%"} width={"99%"}>
      {data && (
        <Table
          columns={columns}
          rows={data && data.map((c) => ({ ...c, id: c.id }))}
          rowHeight={150}
        />
      )}

      {!data && (
        <Grid container mt={5}>
          <Grid item xs={12} sm={12}>
            <NoData />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default memo(MyTriagesTable);
